$('.slider-1').each(function() {
    var slider = $(this);
    
    slider.find('.slides').slick({
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        waitForAnimate: false,
        asNavFor: slider.find('.slider-navigation .col')
    });
    
    slider.find('.slider-navigation .col').slick({
        slidesToShow: slider.find('.slider-navigation .row').attr('data-slides'),
        arrows: false,
        dots: false,
        asNavFor: slider.find('.slides'),
        focusOnSelect: true,
        draggable: false,
        swipe: false
    });
});


// WEBPACK FOOTER //
// ./js/contentelements/slider.js